import React, { useEffect, useRef, useState } from "react";
import InputField from "components/atoms/InputField";
import "./Laporan.scss";
import IcFileRed from "assets/icons/ic_file_red.svg";
import IcFileYellow from "assets/icons/ic_file_yellow.svg";
import IcFileBlue from "assets/icons/ic_file_blue.svg";
import IcFilePink from "assets/icons/ic_file_pink.svg";
import IcFileSkyBlue from "assets/icons/ic_file_skyblue.svg";
import EmptyDataIllustrator from "assets/illustrators/ill_empty_data.svg";
import Button from "components/atoms/Button";
import { useHistory } from "react-router-dom";
import { UserLevel } from "utils/constant";
import { useSelector } from "react-redux";

const laporanGroups = [
  // 1. Data Dasar Penduduk
  {
    id: 1,
    title: "Data Dasar Penduduk",
    children: [
      {
        route: "data-dasar-penduduk",
        title: "Data Dasar Penduduk",
        level: [
          UserLevel.National,
          UserLevel.Province,
          UserLevel.District,
          UserLevel.Fasyankes,
        ],
      },
    ],
  },
  // 2. Laporan Data Kasus
  {
    id: 2,
    title: "Laporan Data Kasus",
    children: [
      {
        route: "zero-report",
        title: "Zero Report",
        level: [
          UserLevel.National,
          UserLevel.Province,
          UserLevel.District,
          UserLevel.Fasyankes,
          UserLevel.BKKInduk,
          UserLevel.BKKWilker,
        ],
      },
      {
        title: "Regmal1",
        route: "regmal1",
        level: [
          UserLevel.National,
          UserLevel.Province,
          UserLevel.District,
          UserLevel.Fasyankes,
          UserLevel.BKKInduk,
          UserLevel.BKKWilker,
        ],
      },
      {
        title: "Regmal 1 WNA",
        route: "regmal1-wna",
        level: [
          UserLevel.National,
          UserLevel.Province,
          UserLevel.District,
          UserLevel.Fasyankes,
        ],
      },
      {
        title: "Regmal 1 Desa Domisili",
        route: "regmal1-desa-domisili",
        level: [
          UserLevel.National,
          UserLevel.Province,
          UserLevel.District,
          UserLevel.Fasyankes,
        ],
      },
      {
        route: "rujukan",
        title: "Regmal 1 Rujukan",
        level: [
          UserLevel.National,
          UserLevel.Province,
          UserLevel.District,
          UserLevel.Fasyankes,
        ],
      },
      {
        title: "Regmal2",
        route: "regmal2",
        level: [
          UserLevel.National,
          UserLevel.Province,
          UserLevel.District,
          UserLevel.Fasyankes,
          UserLevel.BKKInduk,
          UserLevel.BKKWilker,
        ],
      },
      {
        route: "rekap-regmal2",
        title: "Rekap Regmal-2",
        level: [
          UserLevel.National,
          UserLevel.Province,
          UserLevel.District,
          UserLevel.Fasyankes,
        ],
      },
      {
        route: "kasus-pe",
        title: "Kasus PE",
        level: [
          UserLevel.National,
          UserLevel.Province,
          UserLevel.District,
          UserLevel.Fasyankes,
        ],
      },
      {
        route: "tarik-data1",
        title: "Tarik Data-1",
        level: [
          UserLevel.National,
          UserLevel.Province,
          UserLevel.District,
          UserLevel.Fasyankes,
          UserLevel.BKKInduk,
          UserLevel.BKKWilker,
        ],
      },
      {
        route: "validasi-kasus-indigenous",
        title: "Validasi Kasus Indigenous",
        level: [
          UserLevel.National,
          UserLevel.Province,
          UserLevel.District,
          UserLevel.Fasyankes,
        ],
      },
      {
        route: "kelengkapan-perbulan-nasional",
        title: "Kelengkapan Per Bulan Nasional",
        level: [
          UserLevel.National,
          UserLevel.Province,
          UserLevel.District,
          UserLevel.Fasyankes,
        ],
      },
      {
        route: "malaria-kia",
        title: "Malaria - KIA",
        level: [
          UserLevel.National,
          UserLevel.Province,
          UserLevel.District,
          UserLevel.Fasyankes,
        ],
      },
    ],
  },
  // 3. Laporan Data Kasus Publik & Private
  {
    id: 3,
    title: "Laporan Data Kasus Publik & Private",
    children: [
      {
        title: "Regmal 2 Public",
        route: "regmal2-public",
        level: [
          UserLevel.National,
          UserLevel.Province,
          UserLevel.District,
          UserLevel.Fasyankes,
        ],
      },
      {
        title: "Regmal 2 Private",
        route: "regmal2-private",
        level: [
          UserLevel.National,
          UserLevel.Province,
          UserLevel.District,
          UserLevel.Fasyankes,
        ],
      },
      {
        route: "kelengkapan-perbulan-publik",
        title: "Kelengkapan Per Bulan Publik",
        level: [
          UserLevel.National,
          UserLevel.Province,
          UserLevel.District,
          UserLevel.Fasyankes,
        ],
      },
      {
        route: "kelengkapan-perbulan-private",
        title: "Kelengkapan Per Bulan Private",
        level: [
          UserLevel.National,
          UserLevel.Province,
          UserLevel.District,
          UserLevel.Fasyankes,
        ],
      },
      {
        route: "tarik-data1-publik",
        title: "Tarik Data-1 Publik",
        level: [
          UserLevel.National,
          UserLevel.Province,
          UserLevel.District,
          UserLevel.Fasyankes,
          UserLevel.BKKInduk,
          UserLevel.BKKWilker,
        ],
      },
      {
        route: "tarik-data1-private",
        title: "Tarik Data-1 Private",
        level: [
          UserLevel.National,
          UserLevel.Province,
          UserLevel.District,
          UserLevel.Fasyankes,
          UserLevel.BKKInduk,
          UserLevel.BKKWilker,
        ],
      },
    ],
  },
  // 4. Laporan Data Knowlesi
  {
    id: 4,
    title: "Laporan Data Knowlesi",
    children: [
      {
        route: "rekap-individu-data-surveilans-knowlesi-fasyankes",
        title: "Rekap Data Individu Knowlesi Fasyankes",
        level: [
          UserLevel.District,
          UserLevel.Province,
          UserLevel.National,
        ],
      },
      {
        route: "rekap-agregat-surveilans-knowlesi-fasyankes",
        title: "Data Rekap Laporan Konfirmasi PCR untuk P. Knowlesi",
        level: [
          UserLevel.District,
          UserLevel.Province,
          UserLevel.National,
        ],
      },
      {
        route: "rekap-individu-data-surveilans-knowlesi-lab",
        title: "Rekap Data Individu Knowlesi Lab",
        level: [UserLevel.LabTier3, UserLevel.LabTier4, UserLevel.National],
      },
      {
        route: "rekap-individu-data-surveilans-knowlesi-lab-tier-5",
        title: "Rekap Data Individu Knowlesi Lab Tingkat 5",
        level: [UserLevel.LabTier5, UserLevel.National],
      },
      {
        route: "rekap-agregat-data-surveilans-knowlesi-lab-tier-5",
        title: "Rekap Data Agregat Knowlesi Lab Tingkat 5",
        level: [UserLevel.LabTier5, UserLevel.National],
      },
      {
        route: "rekap-agregat-data-surveilans-knowlesi-lab",
        title: "Rekap Agregat Data Surveilans Knowlesi Lab",
        level: [UserLevel.LabTier3, UserLevel.LabTier4, UserLevel.National],
      },
    ],
  },
  // 5. Laporan Modul Ketenagaan
  {
    id: 5,
    title: "Laporan Modul Ketenagaan",
    children: [
      {
        route: "ketenagaan",
        title: "Ketenagaan",
        level: [UserLevel.National, UserLevel.Province, UserLevel.District],
      },
      {
        route: "mikroskopis",
        title: "Mikroskopis Fasyankes / BKK",
        level: [
          UserLevel.National,
          UserLevel.Province,
          UserLevel.District,
          UserLevel.Fasyankes,
          UserLevel.BKKInduk,
          UserLevel.BKKWilker,
        ],
      },
      {
        route: "crosscheck-kab",
        title: "CrossChecker Kab/Kota",
        level: [UserLevel.National, UserLevel.Province, UserLevel.District],
      },
      {
        route: "crosscheck-provinsi",
        title: "CrossChecker Provinsi",
        level: [UserLevel.National, UserLevel.Province],
      },
    ],
  },
  // 6. Laporan Data Diagnostik dan Laboratorium
  {
    id: 6,
    title: "Laporan Data Diagnostik dan Laboratorium",
    children: [
      {
        route: "data-dasar-lab",
        title: "Data Dasar Lab Malaria",
        level: [
          UserLevel.National,
          UserLevel.Province,
          UserLevel.District,
          UserLevel.Fasyankes,
        ],
      },
      {
        route: "verifikasi-uji-silang",
        title: "Verifikasi Uji Silang",
        level: [
          UserLevel.National,
          UserLevel.Province,
          UserLevel.District,
          UserLevel.LabTier2,
          UserLevel.LabTier3,
          UserLevel.Fasyankes,
        ],
      },
      {
        route: "rekap-uji-silang",
        title: "Rekap Uji Silang",
        level: [
          UserLevel.National,
          UserLevel.Province,
          UserLevel.District,
          UserLevel.LabTier2,
          UserLevel.LabTier3,
          UserLevel.Fasyankes,
        ],
      },
      {
        route: "laporan-pme-bulanan",
        title: "Laporan PME Bulanan",
        level: [UserLevel.National, UserLevel.Province, UserLevel.District],
      },
      {
        route: "laporan-pme-tahunan",
        title: "Laporan PME Tahunan",
        level: [UserLevel.National, UserLevel.Province, UserLevel.District],
      },
      // Uji Silang Individu ditambahkan dinamis untuk Fasyankes jnsfas-01 (lihat getGroupChildren)
      {
        route: "laporan-pme-fasyankes",
        title: "Laporan PME Fasyankes",
        level: [UserLevel.Fasyankes],
      },
    ],
  },
  // 7. Laporan Data Reseptifitas dan Vektor
  {
    id: 7,
    title: "Laporan Data Reseptifitas dan Vektor",
    children: [
      {
        route: "reseptifitas",
        title: "Reseptifitas dan Fokus",
        level: [
          UserLevel.National,
          UserLevel.Province,
          UserLevel.District,
          UserLevel.Fasyankes,
        ],
      },
      {
        route: "identifikasi-jentik",
        title: "Identifikasi Jentik",
        level: [
          UserLevel.National,
          UserLevel.Province,
          UserLevel.District,
          UserLevel.Fasyankes,
        ],
      },
      {
        route: "identifikasi-nyamuk",
        title: "Identifikasi Nyamuk",
        level: [
          UserLevel.National,
          UserLevel.Province,
          UserLevel.District,
          UserLevel.Fasyankes,
        ],
      },
      {
        route: "pengendalian-vektor",
        title: "Pengendalian Vektor",
        level: [
          UserLevel.National,
          UserLevel.Province,
          UserLevel.District,
          UserLevel.Fasyankes,
        ],
      },
      {
        route: "rekap-pengendalian-vektor",
        title: "Rekap Pengendalian Vektor",
        level: [
          UserLevel.National,
          UserLevel.Province,
          UserLevel.District,
          UserLevel.Fasyankes,
        ],
      },
      {
        route: "laporan-rekap-kelambu",
        title: "Laporan Rekap Kelambu",
        level: [
          UserLevel.National,
          UserLevel.Province,
          UserLevel.District,
          UserLevel.Fasyankes,
        ],
      },
      {
        route: "laporan-rekap-irs",
        title: "Laporan Rekap IRS",
        level: [
          UserLevel.National,
          UserLevel.Province,
          UserLevel.District,
          UserLevel.Fasyankes,
        ],
      },
      {
        route: "rekap1-pemantauan-jentik",
        title: "Laporan Rekap 1 Data Pemantauan Jentik",
        level: [
          UserLevel.National,
          UserLevel.Province,
          UserLevel.District,
          UserLevel.Fasyankes,
        ],
      },
      {
        route: "rekap2-pemantauan-jentik",
        title: "Laporan Rekap 2 Data Pemantauan Jentik",
        level: [
          UserLevel.National,
          UserLevel.Province,
          UserLevel.District,
          UserLevel.Fasyankes,
        ],
      },
      {
        route: "tren2-pemantauan-jentik",
        title: "Laporan Tren 2 Data Pemantauan Jentik",
        level: [
          UserLevel.National,
          UserLevel.Province,
          UserLevel.District,
          UserLevel.Fasyankes,
        ],
      },
      {
        route: "rekap-kohort-lengkap",
        title: "Laporan Rekap Kohort Lengkap",
        level: [
          UserLevel.National,
          UserLevel.Province,
          UserLevel.District,
          UserLevel.Fasyankes,
        ],
      },
      {
        route: "rekap-master",
        title: "Laporan Rekap Master",
        level: [
          UserLevel.National,
          UserLevel.Province,
          UserLevel.District,
          UserLevel.Fasyankes,
        ],
      },
    ],
  },
  // 8. Laporan Data dan Monitoring Kader
  {
    id: 8,
    title: "Laporan Data dan Monitoring Kader",
    children: [
      {
        route: "data-dan-monitoring-kader",
        title: "Data dan Monitoring Kader",
        level: [
          UserLevel.National,
          UserLevel.Province,
          UserLevel.District,
          UserLevel.Fasyankes,
          UserLevel.SR,
          UserLevel.SSR,
        ],
      },
      {
        route: "kinerja-kader",
        title: "Kinerja Kader",
        level: [
          UserLevel.National,
          UserLevel.Province,
          UserLevel.District,
          UserLevel.Fasyankes,
        ],
      },
      {
        route: "mmp-dan-monitoring-kader-mmp",
        title: "MMP dan Monitoring Kader MMP",
        level: [
          UserLevel.National,
          UserLevel.Province,
          UserLevel.District,
          UserLevel.Fasyankes,
        ],
      },
      {
        route: "kinerja-kader-mmp",
        title: "Kinerja Kader MMP",
        level: [
          UserLevel.National,
          UserLevel.Province,
          UserLevel.District,
          UserLevel.Fasyankes,
        ],
      },
      {
        route: "rekap-mmp",
        title: "Rekap Laporan MMP",
        level: [
          UserLevel.National,
          UserLevel.Province,
          UserLevel.District,
          UserLevel.Fasyankes,
        ],
      },
      {
        route: "cadre-rekap-active",
        title: "Rekap keaktifan kader bulanan",
        level: [UserLevel.SR, UserLevel.SSR],
      },
      {
        route: "cadre-rekap-active-by-last-3-month",
        title: "Rekap Keaktifan Kader 3 Bulan Terakhir",
        level: [UserLevel.SR, UserLevel.SSR],
      },
    ],
  },
  // 9. Laporan Logistik
  {
    id: 9,
    title: "Laporan Logistik",
    children: [
      {
        route: "logistik-stok",
        title: "Logistik Stok",
        level: [
          UserLevel.National,
          UserLevel.Province,
          UserLevel.District,
          UserLevel.Fasyankes,
        ],
      },
      {
        route: "logistik-ed",
        title: "Logistik ED",
        level: [
          UserLevel.National,
          UserLevel.Province,
          UserLevel.District,
          UserLevel.Fasyankes,
        ],
      },
      {
        route: "logistik-stok-out",
        title: "Logistik Stok Out",
        level: [
          UserLevel.National,
          UserLevel.Province,
          UserLevel.District,
          UserLevel.Fasyankes,
        ],
      },
      {
        route: "logistik-pemakaian",
        title: "Logistik Pemakaian",
        level: [UserLevel.National, UserLevel.Province],
      },
    ],
  },
  // 10. Laporan BKK
  {
    id: 10,
    title: "Laporan BKK",
    children: [
      // this bellow menu only for bkk report
      {
        route: "laporan-data-dasar-bkk-wilker",
        title: "Data Dasar BKK Wilker",
        level: [
          UserLevel.BKKWilker,
          UserLevel.BKKInduk,
          UserLevel.National,
          UserLevel.Province,
          UserLevel.District,
        ],
      },
      {
        route: "laporan-data-dasar-bkk-induk",
        title: "Data Dasar BKK Induk",
        level: [
          UserLevel.BKKWilker,
          UserLevel.BKKInduk,
          UserLevel.National,
          UserLevel.Province,
          UserLevel.District,
        ],
      },
      // Hidden: Zero Report BKK merged into Zero Report
      // {
      //   route: "laporan-zero-report-bkk",
      //   title: "Zero Report BKK",
      //   level: [UserLevel.BKKWilker, UserLevel.BKKInduk, UserLevel.National, UserLevel.Province, UserLevel.District],
      // },
      // {
      //   route: "laporan-regmal-1-bkk",
      //   title: "Laporan Regmal 1 BKK",
      //   level: [UserLevel.National, UserLevel.Province, UserLevel.District],
      // },
      // {
      //   route: "laporan-regmal-2-bkk",
      //   title: "Laporan Regmal 2 BKK",
      //   level: [UserLevel.BKKWilker, UserLevel.BKKInduk, UserLevel.National, UserLevel.Province, UserLevel.District],
      // },
      {
        route: "laporan-data-dasar-lab-bkk",
        title: "Laporan Data Dasar Lab BKK",
        level: [
          UserLevel.BKKWilker,
          UserLevel.BKKInduk,
          UserLevel.National,
          UserLevel.Province,
          UserLevel.District,
        ],
      },
      {
        route: "rujukan-bkk",
        title: "Regmal 1 Rujukan - BKK",
        level: [
          UserLevel.National,
          UserLevel.Province,
          UserLevel.District,
          UserLevel.Fasyankes,
        ],
      },
    ],
  },
];

const LaporanPage = () => {
  const { currentUser } = useSelector((state) => state.authReducer);

  const history = useHistory();
  const [filterValue, setFilterValue] = useState("");
  const [activeGroup, setActiveGroup] = useState(null);

  // kartu laporan berupa div, jadi klik cepat berturut-turut dikunci manual
  const clickLockRef = useRef(false);
  const lockClick = (action) => {
    if (clickLockRef.current) return;
    clickLockRef.current = true;
    setTimeout(() => {
      clickLockRef.current = false;
    }, 400);
    action();
  };

  const handleInputChange = (e) => {
    setFilterValue(e.target.value);
  };

  const onLaporanClick = (data) => {
    const module = data.route;
    history.push(`/laporan/${module}`);
  };

  const handleEnterGroup = (groupId) => {
    setActiveGroup(groupId);
    setFilterValue("");
  };

  const handleBackToGroups = () => {
    setActiveGroup(null);
    setFilterValue("");
  };

  const columnsIcon = [
    IcFileRed,
    IcFileYellow,
    IcFileBlue,
    IcFilePink,
    IcFileSkyBlue,
  ];

  const userLevel = currentUser?.level;

  const getVisibleChildren = (group) => {
    let children = group.children;
    // Uji Silang Individu hanya untuk Fasyankes jnsfas-01 (dinamis)
    if (
      group.id === 6 &&
      currentUser?.fasyankes_type_id === "jnsfas-01" &&
      !children.some((l) => l.route === "uji-silang-individu")
    ) {
      children = [
        ...children,
        {
          route: "uji-silang-individu",
          title: "Uji Silang Individu",
          level: [UserLevel.Fasyankes],
        },
      ];
    }
    return children.filter((laporan) => laporan.level.includes(userLevel));
  };

  const renderGrid = (items) => (
    <div className="row" style={{ gap: "16px", margin: "0" }}>
      {items.map((laporan, colIndex) => (
        <div
          onClick={() => lockClick(() => onLaporanClick(laporan))}
          className="col grid-item"
          style={{ marginBottom: "16px" }}
          key={colIndex}
        >
          <div className="icon-wrapper">
            <img
              src={columnsIcon[colIndex % columnsIcon.length]}
              alt="Icon"
            />
          </div>
          <h3>{laporan.title}</h3>
        </div>
      ))}
    </div>
  );

  const renderGroupGrid = (groups) => (
    <div className="row" style={{ gap: "16px", margin: "0" }}>
      {groups.map((group, colIndex) => (
        <div
          key={group.id}
          className="col grid-item report-group-card"
          style={{ marginBottom: "16px" }}
          onClick={() => lockClick(() => handleEnterGroup(group.id))}
        >
          <div className="icon-wrapper">
            <img src={columnsIcon[colIndex % columnsIcon.length]} alt="Icon" />
          </div>
          <h3>{group.title}</h3>
        </div>
      ))}
    </div>
  );

  const renderEmptyState = () => (
    <div className="empty-data-container">
      <img src={EmptyDataIllustrator} alt="Empty Data illustrator" />
      <h3>Laporan yang Kamu Cari Tidak Ditemukan</h3>
      <p>Pastikan nama laporan yang kamu masukkan sudah benar</p>
      <Button
        variant={"primary"}
        size={"normal"}
        onClick={() => setFilterValue("")}
      >
        Lihat Semua Laporan
      </Button>
    </div>
  );

  // Mode A: search global di luar grup — tampilkan sub yang cocok secara flat
  const activeGroupData = laporanGroups.find((g) => g.id === activeGroup);
  let groupChildren = activeGroupData
    ? getVisibleChildren(activeGroupData)
    : [];

  // Mode B: search hanya di dalam grup aktif
  if (activeGroupData && filterValue) {
    groupChildren = groupChildren.filter((laporan) =>
      laporan.title.toLowerCase().includes(filterValue.toLowerCase()),
    );
  }

  // Mode A: sub yang cocok dari semua grup (di luar grup, saat search aktif)
  const flatSearchResults = activeGroupData
    ? []
    : laporanGroups
        .flatMap((group) => getVisibleChildren(group))
        .filter((laporan) =>
          laporan.title.toLowerCase().includes(filterValue.toLowerCase()),
        );

  // Grup yang punya minimal satu laporan sesuai level user
  const visibleGroups = laporanGroups.filter(
    (group) => getVisibleChildren(group).length > 0,
  );

  useEffect(() => {
    document.title = "SISMAL | Laporan";
  }, []);

  return (
    <div className="dashboard-wrapper">
      <div className="header">
        {activeGroupData ? (
          <div className="group-header">
            <button className="btn-back" onClick={handleBackToGroups}>
              &larr; Kembali
            </button>
            <h1>{activeGroupData.title}</h1>
          </div>
        ) : (
          <h1>Laporan</h1>
        )}
        <div className="search-wrapper">
          <InputField
            placeholder={"Cari laporan disini"}
            hasShadow={true}
            value={filterValue}
            onChange={handleInputChange}
          />
        </div>
      </div>

      {activeGroupData ? (
        // Tampilan di dalam grup
        <div className="items-report">
          {groupChildren.length === 0 ? (
            renderEmptyState()
          ) : (
            renderGrid(groupChildren)
          )}
        </div>
      ) : filterValue ? (
        // Mode A: hasil search flat (seperti perilaku lama)
        <div className="items-report">
          {flatSearchResults.length === 0 ? (
            renderEmptyState()
          ) : (
            renderGrid(flatSearchResults)
          )}
        </div>
      ) : (
        // Tampilan luar: grid kartu kotak nama grup — 5 kartu per baris (pola yang sama dengan sub laporan)
        <div className="items-report">
          {renderGroupGrid(visibleGroups)}
        </div>
      )}
    </div>
  );
};

export default LaporanPage;
